export default "__VITE_ASSET__B_eZuL6K__"